import React from 'react';

const VerticalStretch = () => {
    return (
        <div className="flex flex-col flex-grow justify-center h-0">&nbsp;</div>
    );
};

export default VerticalStretch;